module.exports = __webpack_public_path__ + "img/d11.489104bc.png";